import { useCallback, useContext } from 'react'
import { joinBasePath } from '../utils/joinBasePath'
import { BasePathContext } from './basePathContext'

/**
 * Resolves landing-internal paths against the path the landing is mounted at,
 * so the same landing works at `/` and at `/subpath` without code changes.
 */
export const useBasePath = () => {
  const basePath = useContext(BasePathContext)

  const resolvePath = useCallback((path: string) => joinBasePath(basePath, path), [basePath])

  return { basePath, resolvePath }
}
